//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA ATUALIZAR INTEGRAÇÃO ---------------//
// Responsável por atualizar a integração via API
export default async function updateIntegrationService(formData) {
    try {
        const response = await api.put("/integracoes", formData);
        toast.success("Integração atualizada com sucesso");
        if (response) {
            return true;
        }
    } catch (err) {
        console.error("❌ Erro ao atualizar integração:", err);
        toast.error("Erro ao atualizar integração");
        return false;
    }
}